import { ThemeProvider } from '@material-tailwind/react';

import { AppProvider } from '@/app/components/provider';
import { AppRouter } from '@/app/router/router';
import { InputTheme } from '@/shared/components/ui/label-input';
import { TextareaTheme } from '@/shared/components/ui/label-textarea';

export const App = () => {
  const customTheme = {
    input: InputTheme,
    textarea: TextareaTheme,
  };
  return (
    <ThemeProvider value={customTheme}>
      <AppProvider>
        <AppRouter />
      </AppProvider>
    </ThemeProvider>
  );
};
